import { make } from 'vuex-pathify'

const state = {
  data: {},
}

const mutations = make.mutations(state)

const getters = {}

const actions = {}

export const transportationTypes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
